/**
 * Get addres parts from data locations object
 */

import deconstructLocation from './deconstructLocation';

export default function deconstructAddress(location) {
  if (!location) {
    return {};
  }

  const address = {
    street_text: '',
    street: '',
    suburb: '',
    state: '',
    geo: '',
    map_pin: '',
    postcode: '',
  };
  let parts;

  if (
    location.address &&
    (location.address.street || location.address.suburb)
  ) {
    const searchLocation = location;
    parts = deconstructLocation(searchLocation.address.suburb);
    address.street_text = searchLocation.address.street_text;
    address.street = searchLocation.address.street;
    address.map_pin = searchLocation.address.map_pin;
    address.suburb =
      !searchLocation.address.display_suburb_empty &&
      searchLocation.address.display_suburb
        ? searchLocation.address.display_suburb
        : parts.suburb;
    address.state =
      !searchLocation.address.display_suburb_empty &&
      searchLocation.address.display_suburb_state
        ? searchLocation.address.display_suburb_state
        : parts.state;
    address.postcode = parts.postcode;
    address.geo = searchLocation.address.geo;
  }

  return address;
}
